import { mapGetters } from 'vuex';
import enJSON from '@/common/utilities/lang/en/termsofuse.js';
import esJSON from '@/common/utilities/lang/es/termsofuse.js';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import { scrollTo } from '@/common/utilities/nojq/_scrollto.js';

export default {
    name: 'vtermsofuse',
    components: {
        mvtHeader,
        mvtFooter,
        mvtDialogCenter,
    },
    inject: ['$eventBus'],
    data() {
        return {
            currentFullYear: new Date().getFullYear(),
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    methods: {
        checkHashChange() {
            var hash = location.hash;
            if (hash) {
                scrollTo(hash.replace('#', ''));
            }
        },
        getContent(value) {
            return this.molang(value);
        },
    },
    mounted() {
        this.checkHashChange();
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'termsofuse', en: enJSON, es: esJSON });
    },
};
